<template>
    <div class="agreements section">
        <h3>Review the terms</h3>

        <div class="agreementWrapper">
            <h4>Rental Agreement</h4>
            <ul>
                <li>
                    Rates are for dates and maximum parties noted.
                </li>
                <li>
                    Additional guests above the maximum contracted for may result in loss of security deposit and/or
                    additional charges. Please let us know if the total number of guests changes in order to avoid any
                    misunderstandings.
                </li>
                <li v-if="datePaymentDue">
                    Final payment is due on {{ datePaymentDue.format('MMMM D, YYYY') }}. We will attempt to charge the
                    credit card on file for the remaining balance on the payment due day. You may also use the provided
                    invoice link to make a payment before the due date.
                </li>
                <li>
                    If a reservation is canceled by a guest more than 30 days prior to the arrival date, payments will
                    be refunded only if the property can be rented to another party at the same rate for the same time
                    period. A $50 administrative fee will be retained for each cancellation. There are no refunds for
                    cancellations within 30 days of scheduled arrival.
                </li>
                <li>
                    Check-in is 3:30 pm; check-out is 9:00 am. There is a $25 charge for each hour or fraction thereof
                    that guest stays after the contracted departure time.
                </li>
                <li>
                    Guests are liable for all replacements and repairs needed to attain the same condition as when
                    occupancy commenced other than normal cleaning and laundry of towels and linens.
                    We reserve the right to charge the credit card on file for any damages or extra cleaning required.
                </li>
                <li>
                    No pets are allowed unless by prior arrangement and with paid fee.
                </li>
                <li>
                    Smoking is not permitted anywhere on the property.
                </li>
            </ul>
        </div>
        <div class="agree">
            I have read and agree to the terms in the Rental Agreement *:
            <input
                type="checkbox"
                v-model="agreements.rental.agreed"
                :value="true"
                style="margin-left: 10px;"
                :disabled="readonly"
            >
<!--            :disabled="!agreements.rental.viewed"-->
        </div>

        <div v-if="agreements.pet.required" class="agreementWrapper">
            <h4>Pet Agreement</h4>
            <ul>
                <li>A maximum of two pets is allowed.</li>
                <li>A non-refundable pet fee may be charged.</li>
                <li>Dogs that bark excessively are not allowed.</li>
                <li>Pets must be house broken, flea free, well behaved, and quiet.</li>
                <li>Pets must be clean and dry before entering the house.</li>
                <li>Pets are not allowed on furniture or bedding. If you have a lap pet, bring a towel or blanket.</li>
                <li>You must clean up after your pet in the house and in the yard.</li>
                <li>You are responsible for any damage, odors, stains, or other problems caused by your pet. Problems caused by your pet will result in forfeiture of some or all of your damage deposit.</li>
                <li>Dogs may not be left in house unattended unless crated (or very calm) and quiet.</li>
            </ul>
        </div>
        <div v-if="agreements.pet.required" class="agree">
            I have read and agree to the terms in the Pet Agreement *:
            <input
                type="checkbox"
                v-model="agreements.pet.agreed"
                :value="true"
                style="margin-left: 10px;"
                :disabled="readonly"
            >
<!--            :disabled="!agreements.pet.viewed"-->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        agreements: {
            type: Object,
        },
        datePaymentDue: {
            type: Object,
        },
        validator: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    }
}
</script>

<style lang="scss">
.agreements {
    .agreementWrapper {
        width: 90%;
        margin: 20px auto auto auto;
        padding: 10px;
        border: 1px solid #bbb;

        @media (max-width: 600px) {
            width: 100%;
        }

        h4 {
            font-weight: bold;
            text-decoration: underline;
            margin: 0 0 10px 0;
        }
    }
    .agree {
        font-size: 110%;
        font-weight: bold;
        margin: 15px 15px 10px 5%;
    }
}
</style>
